var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { getSitecoreTracker, getCookie, setCookie, removeCookie, UniformCookieNames, addSubscriptionsForTrackerCookies, getDispatchersFromTrackingConfig, getTrackerCookieSettings, addVisits as addVisitsToVisitor } from '@uniformdev/tracking';
import { getNullLogger } from '@uniformdev/common';
import { getClientScriptLoader } from '@uniformdev/common-client';
import { getSubscriptionManager, getDefaultConsoleLogger } from '@uniformdev/optimize-common-sitecore';
import axios from 'axios';
function getLogger(prefix, settings) {
  if ((settings === null || settings === void 0 ? void 0 : settings.debug) !== true) return getNullLogger();
  if (settings.logger) return settings.logger;
  var logger = getDefaultConsoleLogger("optimize-tracker");
  logger.debug("Uniform tracking - ".concat(prefix, " - No logger was set in the settings but debug is enabled so use the default console logger."), {
    settings: settings
  });
  return logger;
}
function shouldAddSubscriptionsForContextCookies(settings) {
  return (settings === null || settings === void 0 ? void 0 : settings.mode) == "mvc";
}
function getTrackingConfig(settings, logger) {
  var _a, _b;
  if ((_a = settings === null || settings === void 0 ? void 0 : settings.context) === null || _a === void 0 ? void 0 : _a.tracking) {
    logger.debug("Uniform tracking - initializeTracker - Using tracking config from settings to determine tracker cookie types.", {
      settings: settings
    });
    return settings.context;
  }
  if ((_b = window.uniform) === null || _b === void 0 ? void 0 : _b.tracking) {
    logger.debug("Uniform tracking - initializeTracker - Using tracking config from global object to determine tracker cookie types.", {
      global: window.uniform
    });
    return window.uniform.tracking;
  }
}
function addSubscriptionsForContextCookies(trackingConfig, subs, settings, logger) {
  var cookieSettings = getTrackerCookieSettings(trackingConfig);
  addSubscriptionsForTrackerCookies(subs, {
    cookieSettings: cookieSettings,
    getCookieName: settings === null || settings === void 0 ? void 0 : settings.getCookieName,
    getCookieValueFromVisitor: settings === null || settings === void 0 ? void 0 : settings.getCookieValueFromVisitor,
    getCookieValueFromVisit: settings === null || settings === void 0 ? void 0 : settings.getCookieValueFromVisit,
    logger: logger,
    loggerPrefix: "Uniform tracking - initializeTracker",
    getCookie: getCookie,
    removeCookie: removeCookie,
    setCookie: setCookie
  });
}
export var gaNewElem = {};
export var gaElems = {};
function gaInit() {
  var currdate = new Date();
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * currdate;
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga', gaNewElem, gaElems);
}
function getFunction(name) {
  if (!name) {
    return;
  }
  var parts = name.split('.');
  if (parts.length > 1 && parts[0] == "window") {
    parts.splice(0, 1);
  }
  var callback = window;
  for (var i = 0; i < parts.length; i++) {
    if (!callback) {
      break;
    }
    callback = callback[parts[i]];
  }
  if (callback == undefined || typeof callback !== "function") {
    return;
  }
  return callback;
}
/**
 * Prepares the tracker and makes it available as a global JavaScript object.
 * No data is tracked when this function is called.
 * @param settings
 */
export function initializeTracker(settings) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
  return __awaiter(this, void 0, void 0, function () {
    var logger, trackingConfig, scripts, scriptLoader, error_1, addSubscription, subscriptions, onDispatch, onBeforeDispatchData, dispatchers, campaignParameters, goalParameters, sessionTimeout, args, tracker;
    return __generator(this, function (_m) {
      switch (_m.label) {
        case 0:
          logger = getLogger("initializeTracker", settings);
          trackingConfig = getTrackingConfig(settings, logger);
          if (!trackingConfig) {
            logger.error("Uniform tracking - initializeTracker - Unable to resolve tracking config so tracker cannot be initialized.", {
              settings: settings
            });
            return [2 /*return*/, Promise.resolve(undefined)];
          }
          if (!((_a = trackingConfig.settings) === null || _a === void 0 ? void 0 : _a.scripts)) return [3 /*break*/, 4];
          scripts = __assign({}, trackingConfig.settings.scripts);
          //
          //If the optimize script is included, remove it because this is that script.
          if (scripts.optimize) {
            delete scripts.optimize;
            logger.debug("Uniform tracking - initializeTracker - Optimize script was removed from the collection of client scripts to load because that script is running this code.", {
              scripts: scripts
            });
          }
          scriptLoader = getClientScriptLoader();
          if (!scriptLoader) {
            logger.error("Uniform tracking - initializeTracker - Unable to resolve script loader so tracker cannot be initialized.", {
              trackingConfig: trackingConfig
            });
            return [2 /*return*/, Promise.resolve(undefined)];
          }
          _m.label = 1;
        case 1:
          _m.trys.push([1, 3,, 4]);
          return [4 /*yield*/, scriptLoader.load(scripts, {
            logger: logger
          })];
        case 2:
          _m.sent();
          logger.debug("Uniform tracking - initializeTracker - Scripts finished loading.", {
            scripts: scripts
          });
          return [3 /*break*/, 4];
        case 3:
          error_1 = _m.sent();
          logger.error("Uniform tracking - initializeTracker - Error occurred while loading scripts so tracker cannot be initialized.", {
            trackingConfig: trackingConfig,
            scripts: scripts,
            error: error_1
          });
          return [2 /*return*/, Promise.reject(error_1)];
        case 4:
          addSubscription = function addSubscription(name, type) {
            if (!name) return;
            var callback = getFunction(name);
            if (callback == undefined || typeof callback !== "function") {
              logger.error("Uniform tracking - initializeTracker - Unable to add a tracker subscription because the specified function does not exist.", {
                name: name,
                type: type
              });
              return;
            }
            if (callback) {
              subscriptions.subscribe(type, callback);
            }
          };
          subscriptions = getSubscriptionManager("OPTIMIZE_JS_TRACKER_SUBS", false, logger);
          //
          //Add handlers for setting context data in cookies.
          if (shouldAddSubscriptionsForContextCookies(settings)) {
            logger.debug("Uniform tracking - initializeTracker - Adding subscriptions for context cookies.", {
              settings: settings
            });
            addSubscriptionsForContextCookies(trackingConfig, subscriptions, settings, logger);
          }
          //
          //Add custom handlers specified on the settings.
          addSubscription(settings.onTrackingFinished, "tracking-finished");
          addSubscription(settings.onVisitCreated, "visit-created");
          addSubscription(settings.onVisitUpdated, "visit-updated");
          addSubscription(settings.onVisitorUpdated, "visitor-updated");
          onDispatch = getFunction(settings.onDispatch);
          onBeforeDispatchData = getFunction(settings.onBeforeDispatchData);
          dispatchers = getDispatchersFromTrackingConfig(trackingConfig, {
            getCookie: getCookie,
            logger: logger,
            loggerPrefix: "Uniform tracking - initializeTracker",
            removeCookie: removeCookie,
            setCookie: setCookie,
            ga: {
              initializeGa: function initializeGa(destination, logger) {
                if (!window.ga) {
                  logger.error("Uniform tracking - initializeTracker - The global function ga is not defined, so initializing the GA library.", {
                    destination: destination
                  });
                  gaInit();
                }
                if (!window.ga) {
                  logger.error("Uniform tracking - initializeTracker - The global function ga is not defined, suggesting the GA library has not been loaded.", {
                    destination: destination
                  });
                  return false;
                }
                if (!destination.trackingIds) {
                  logger.debug("Uniform tracking - initializeTracker - No tracking ids set on GA destination so no GA tracker objects will be created.", {
                    destination: destination
                  });
                  return false;
                }
                destination.trackingIds.forEach(function (trackingId) {
                  try {
                    window.ga("create", trackingId, "auto");
                    logger.debug("Uniform tracking - initializeTracker - GA tracker object was created.", {
                      trackingId: trackingId,
                      destination: destination
                    });
                  } catch (error) {
                    logger.error("Uniform tracking - initializeTracker - Error while creating GA tracker object.", {
                      trackingId: trackingId,
                      error: error
                    });
                  }
                });
                return true;
              }
            },
            ga4: {
              initializeGa4: function initializeGa4(destination, logger) {
                var _a;
                logger.debug("Uniform tracking - initializeTracker - do something", destination);
                if (!window.dataLayer) {
                  logger.debug("Uniform tracking - initializeTracker - initialize dataLayer for GA4.", destination);
                  window.dataLayer = [];
                }
                window.gtag = function () {
                  window.dataLayer.push(arguments);
                };
                if (((_a = destination.measurementIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                  window.gtag('js', new Date());
                  destination.measurementIds.forEach(function (id) {
                    logger.debug("Uniform tracking - initializing GA4 property.", id);
                    window.gtag('config', id);
                    logger.debug("Uniform tracking - GA4 property initialized.", id);
                  });
                }
                return true;
              }
            }
          });
          campaignParameters = (_b = settings.campaignParameters) !== null && _b !== void 0 ? _b : (_d = (_c = trackingConfig.settings) === null || _c === void 0 ? void 0 : _c.campaigns) === null || _d === void 0 ? void 0 : _d.parameters;
          goalParameters = (_e = settings.goalParameters) !== null && _e !== void 0 ? _e : (_g = (_f = trackingConfig.settings) === null || _f === void 0 ? void 0 : _f.goals) === null || _g === void 0 ? void 0 : _g.parameters;
          sessionTimeout = (_h = settings.sessionTimeout) !== null && _h !== void 0 ? _h : (_k = (_j = trackingConfig.settings) === null || _j === void 0 ? void 0 : _j.session) === null || _k === void 0 ? void 0 : _k.timeout;
          args = {
            campaignParameters: campaignParameters,
            dispatchers: dispatchers,
            onDispatch: onDispatch,
            onBeforeDispatchData: onBeforeDispatchData,
            goalParameters: goalParameters,
            sessionTimeout: sessionTimeout !== null && sessionTimeout !== void 0 ? sessionTimeout : 20,
            storage: (_l = settings.storage) !== null && _l !== void 0 ? _l : "default",
            subscriptions: subscriptions,
            type: "js"
          };
          tracker = getSitecoreTracker(args, logger);
          if (!tracker) {
            logger.error("Uniform tracking - initializeTracker - No tracker was returned from getSitecoreTracker.", {
              args: args
            });
            return [2 /*return*/, Promise.resolve(undefined)];
          }
          //
          //Set the tracker on the global object.
          if (!window.uniform) {
            window.uniform = {};
          }
          window.uniform.tracker = tracker;
          return [2 /*return*/, Promise.resolve(tracker)];
      }
    });
  });
}
/**
 * Tracks using tracking data from the global JavaScript object.
 * If the tracker is not already initialized, this function
 * initializes it.
 * @param settings
 */
export function doTracking(settings) {
  var _this = this;
  var _a;
  var logger = getLogger("doTracking", settings);
  if (!window.uniform) {
    return;
  }
  var source = settings.source;
  if (!source) {
    logger.error("Uniform tracking - doTracking - No source was specified.", {
      settings: settings
    });
    return;
  }
  var context = (_a = settings.context) !== null && _a !== void 0 ? _a : window.uniform;
  if (!context) {
    logger.warn("Uniform tracking - doTracking - No context was was resolved.", {
      settings: settings
    });
    return;
  }
  var useTracker = function useTracker(tracker) {
    return __awaiter(_this, void 0, void 0, function () {
      var visitorId, visitId, trackingSettings, callback, results, parts, oldValue, newValue;
      var _a, _b, _c, _d, _e, _f;
      return __generator(this, function (_g) {
        switch (_g.label) {
          case 0:
            if (!tracker) {
              logger.error("Uniform tracking - doTracking - No tracker is available.", {
                settings: settings
              });
              return [2 /*return*/];
            }
            logger.debug("Uniform tracking - doTracking - Tracker is available.", {
              settings: settings
            });
            visitorId = getCookie(UniformCookieNames.VisitorId);
            if (visitorId) {
              logger.debug("Uniform tracking - doTracking - Visitor id was retrieved from cookie.", {
                visitorId: visitorId,
                cookie: UniformCookieNames.VisitorId
              });
            } else {
              logger.debug("Uniform tracking - doTracking - No visitor id was retrieved from cookie.", {
                cookie: UniformCookieNames.VisitorId
              });
            }
            visitId = getCookie(UniformCookieNames.VisitId);
            if (visitId) {
              logger.debug("Uniform tracking - doTracking - Visit id was retrieved from cookie.", {
                visitId: visitId,
                cookie: UniformCookieNames.VisitId
              });
            } else {
              logger.debug("Uniform tracking - doTracking - No visit id was retrieved from cookie.", {
                cookie: UniformCookieNames.VisitId
              });
            }
            trackingSettings = {
              visitId: visitId,
              visitorId: visitorId,
              createVisitor: true,
              silent: settings.silent,
              lastActivity: (_c = (_b = (_a = window.uniform) === null || _a === void 0 ? void 0 : _a.tracking) === null || _b === void 0 ? void 0 : _b.visit) === null || _c === void 0 ? void 0 : _c.lastActivity,
              isNew: (_f = (_e = (_d = window.uniform) === null || _d === void 0 ? void 0 : _d.tracking) === null || _e === void 0 ? void 0 : _e.visit) === null || _f === void 0 ? void 0 : _f.isNew
            };
            if (settings.onVisitorInitialized) {
              callback = window[settings.onVisitorInitialized];
              if (!callback) {
                logger.error("Uniform tracking - doTracking - Handler for visitor initialization was specified but the function does not exist.", {
                  onVisitorInitialized: settings.onVisitorInitialized
                });
              } else {
                trackingSettings.onVisitorInitialized = callback;
                logger.debug("Uniform tracking - doTracking - Handler for visitor initialization set on tracking settings.", {
                  onVisitorInitialized: settings.onVisitorInitialized
                });
              }
            }
            return [4 /*yield*/, tracker.track(source, context, trackingSettings)];
          case 1:
            results = _g.sent();
            logger.debug("Uniform tracking - doTracking - Tracking results were returned.", {
              results: results
            });
            if (results) {
              if (results.visitor) {
                setCookie(UniformCookieNames.VisitorId, results.visitor.id, 3650);
                logger.debug("Uniform tracking - doTracking - Visitor id cookie was updated.", {
                  visitorId: visitorId,
                  cookie: UniformCookieNames.VisitorId
                });
              }
              if (results.visit) {
                setCookie(UniformCookieNames.VisitId, results.visit.id);
                logger.debug("Uniform tracking - doTracking - Visit id cookie was updated.", {
                  visitorId: visitorId,
                  cookie: UniformCookieNames.VisitId
                });
                parts = [new Date(results.visit.start).getTime(), new Date(results.visit.updated).getTime()];
                if (settings.sessionTimeout) {
                  parts.push(settings.sessionTimeout);
                }
                oldValue = getCookie(UniformCookieNames.VisitState);
                newValue = parts.join("|");
                setCookie(UniformCookieNames.VisitState, newValue);
                logger.debug("Uniform tracking - doTracking - Visit state cookie was updated.", {
                  old: oldValue,
                  new: newValue,
                  cookie: UniformCookieNames.VisitState
                });
              }
            }
            return [2 /*return*/];
        }
      });
    });
  };
  if (window.uniform.tracker) {
    logger.debug("Uniform tracking - doTracking - Using the tracker set on the global object.", {
      settings: settings
    });
    useTracker(window.uniform.tracker);
  } else {
    initializeTracker(settings).then(function (tracker) {
      logger.debug("Uniform tracking - doTracking - Using the newly initialized tracker.", {
        settings: settings
      });
      useTracker(tracker).then(function () {
        logger.debug("Uniform tracking - doTracking - Tracking is finished.", {
          settings: settings
        });
      });
    });
  }
}
export function addVisits(visits, visitor) {
  return addVisitsToVisitor(visits, visitor);
}
export function getHistory(siteName, visitor, logger) {
  return __awaiter(this, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!siteName) return [2 /*return*/, Promise.reject("Sitecore site name must be specified.")];
          if (!(visitor === null || visitor === void 0 ? void 0 : visitor.id)) return [2 /*return*/, Promise.reject("Uniform visitor must be specified.")];
          return [4 /*yield*/, axios.get("/uniform/api/content/".concat(siteName, "/xdb/history/").concat(visitor.id))];
        case 1:
          response = _a.sent();
          logger.debug("Uniform tracking - getHistory - Data retrieved.", {
            data: response.data
          });
          return [2 /*return*/, Promise.resolve(response.data)];
      }
    });
  });
}